import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import { resetVitrineData } from "redux/reducers/criarVitrineReducer";

import VitrineWizardShell from "../criar-vitrine/components/vitrine-wizard-shell";
import { VITRINE_B2B_LIST_PATH } from "../criar-vitrine/utils/vitrine-b2b-routes";

export default function EditarVitrine() {
  const { idVitrineVirtualB2b } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(resetVitrineData());
  }, [dispatch, idVitrineVirtualB2b]);

  useEffect(() => {
    if (!idVitrineVirtualB2b) {
      history.replace(VITRINE_B2B_LIST_PATH);
    }
  }, [idVitrineVirtualB2b, history]);

  if (!idVitrineVirtualB2b) {
    return null;
  }

  return (
    <VitrineWizardShell
      key={idVitrineVirtualB2b}
      mode="edit"
      vitrineId={idVitrineVirtualB2b}
    />
  );
}
